// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */ import { ReactComponent as HelpCircleDefault } from '../../../../../ui-v3/src/assets/icons/default/general/help-circle.svg?react';
import { ReactComponent as HelpCircleSolid } from '../../../../../ui-v3/src/assets/icons/solid/general/HELP-CIRCLE.svg?react';
import { createIcons } from '../../Icon';
const HelpCircleIcon = /* @__PURE__ */ createIcons('HelpCircle', {
    default: HelpCircleDefault,
    solid: HelpCircleSolid
});
HelpCircleIcon.supportedTypes = [
    'default',
    'solid'
];
HelpCircleIcon.category = 'general';
export default HelpCircleIcon;
